export class RecaptchaService {
  private key = '6LfEcwArAAAAAEnJD6TnxuosRZcbk5X2z01WItJB';

  loadRecaptcha(): void {
    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${this.key}`;
    document.head.appendChild(script);
  }

  verify(): Promise<string> {
    return new Promise((resolve: (token: string) => void) => {
      const recaptcha = window.grecaptcha;
      if (!recaptcha) {
        void setTimeout(() => {
          void this.verify().then(resolve);
        }, 200);
        return;
      }

      recaptcha.ready(() => {
        recaptcha.execute(this.key, { action: 'verify' }).then(resolve);
      });
    });
  }
}
